import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain min-h-screen bg-[#0A0A0A] flex items-center justify-center px-5">
      <div className="w-full max-w-md relative z-10">
        <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-neutral-400 hover:text-white mb-8 text-sm uppercase tracking-widest">
          <ArrowLeft size={16} /> Volver al sitio
        </Link>
        <div className="rounded-3xl border border-white/10 bg-[#121212] p-8 md:p-10">
          <span className="text-xs tracking-[0.25em] uppercase font-bold text-[#FF5A00]">Panel de administración</span>
          <h1 className="font-display uppercase text-4xl mt-3 leading-none">El Rey del Sabor</h1>
          <p className="text-neutral-400 mt-3 text-sm">Ingresa para editar el menú, las fotos y la información.</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-neutral-400">Correo</label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full rounded-xl bg-[#0A0A0A] border border-white/10 px-4 py-3 focus:border-[#FF5A00] focus:ring-2 focus:ring-[#FF5A00]/30 focus:outline-none transition"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-neutral-400">Contraseña</label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full rounded-xl bg-[#0A0A0A] border border-white/10 px-4 py-3 focus:border-[#FF5A00] focus:ring-2 focus:ring-[#FF5A00]/30 focus:outline-none transition"
              />
            </div>
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full rounded-full bg-[#FF5A00] hover:bg-[#FF7A33] text-black font-bold uppercase tracking-wide py-4 transition-all hover:scale-[1.02] disabled:opacity-60"
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
